import { Radar, RadarChart, PolarGrid, PolarAngleAxis, ResponsiveContainer } from "recharts";

export function OpportunityRadar({ radar, height = 300 }) {
  const entries = Object.entries(radar);
  const data = entries.filter(([, v]) => v != null).map(([k, v]) => ({ dim: k, value: v }));
  const missing = entries.filter(([, v]) => v == null).map(([k]) => k);
  return (
    <div>
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="hsl(217 33% 18%)" />
          <PolarAngleAxis
            dataKey="dim"
            tick={{ fill: "hsl(215 20% 62%)", fontSize: 11, fontFamily: "JetBrains Mono" }}
          />
          <Radar
            dataKey="value"
            stroke="#10b981"
            fill="#10b981"
            fillOpacity={0.28}
            strokeWidth={2}
            dot={{ r: 2.5, fill: "#10b981" }}
          />
        </RadarChart>
      </ResponsiveContainer>
      {missing.length > 0 && (
        <p className="text-[11px] text-slate-500 font-mono text-center -mt-1" data-testid="radar-not-verified">
          Not verified (excluded): {missing.join(", ")}
        </p>
      )}
    </div>
  );
}
